import React, { useState } from "react";
import { AppContext } from "./contexts";
import DsConfig from "./style";
import Routers from "./routes";
import { redirects } from "./config";

const App = () => {
  const [context, setContext] = useState({
    setContext: (newCtx) => {
      setContext((oldCtx) => ({ ...oldCtx, ...newCtx }));
    },
    navigateTo: window.location.pathname,
    showCookiesModal: false,
    showCookieDisclaimer: false,
  });

  const forceRedirect = redirects.find(
    ([de]) => decodeURI(window.location.pathname) === de
  );

  if (forceRedirect) {
    const [, para] = forceRedirect;
    window.location.href = para;

    return null;
  }

  return (
    <AppContext.Provider value={context}>
      <DsConfig>
        <Routers />
      </DsConfig>
    </AppContext.Provider>
  );
};

App.propTypes = {};

export default App;
